__turbopack_context__.v({
  "className": "m17qQa_className",
  "variable": "m17qQa_variable",
});
